module.exports = __webpack_public_path__ + "static/media/bg.e37cc893.png";